import "./VastuImg.css";
import { useHrStyles } from "../../Context/HRContext";
import { Button } from "react-bootstrap";

export default function VastuImg() {
  const hrStyles = useHrStyles();

  return (
    <div className="interior-img-content">
      <h1 className="Int-heading">Vastu Insights</h1>
      <p className="Int-text">
        Vastu Shastra is an ancient practice that brings balance, prosperity,
        and positive energy to any space. At BEAMS, we integrate Vastu
        principles into our architectural and design process, ensuring that
        every space is aligned with the natural forces that influence
        well-being. Our Vastu insights guide the placement of elements, colors,
        and materials to create environments that are harmonious and full of
        positive energy. Whether you're designing a home or a workplace, our
        Vastu expertise helps you create a space that promotes health, wealth,
        and happiness.
      </p>
      <Button
        href="/Contact"
        variant="danger"
        size="lg"
        className="centered-button"
      >
        Contact Us
      </Button>
      <hr style={hrStyles} />
    </div>
  );
}
